import React, { useEffect, useState, useRef } from "react";
import {
  Alert as MuiAlert,
  Box,
  Grid,
  DialogActions,
  Button,
  CircularProgress,
} from "@mui/material";
import { spacing } from "@mui/system";
import * as Yup from "yup";
import styled from "@emotion/styled";
import { useTranslation } from "react-i18next";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm, FormProvider } from "react-hook-form";
import ReplayIcon from "@mui/icons-material/Replay";
import { useDispatch } from "react-redux";

import { useDialog } from "../../../../contexts/DialogContext";
import useUser from "../../../../hooks/useUser";
import CustomTextField from "../../../../components/CustomTextField";
import CustomCheckBox from "../../../../components/CustomCheckBox";

import { showSuccessSnackbar, showErrorSnackbar } from "../../../../redux/slices/snackbar";

const Alert = styled(MuiAlert)(spacing);

const AutoRenewal = (props) => {
  const dispatch = useDispatch();
  const { isRenewSubmitting, addAutoRenewal } = useUser();
  const { user } = props;
  const { t } = useTranslation();

  const methods = useForm({});
  const {
    reset,
    handleSubmit,
    watch,
    resetField,
    formState: { errors },
    control,
  } = methods;
  const { unSetDialog, openDialog } = useDialog();

  React.useEffect(() => {
    if (Object.keys(user).length !== 0) {
      const initialValues = {
        radUserId: user.radUserId,
        isEnabled: user.isEnabledAutoRenewal,
      };
      reset(initialValues);
    }
  }, [user]);

  const onSubmit = async (data) => {
    try {
      const payload = {
        radUserId: user.radUserId,
        isEnabled: data.isEnabled,
      };
      await addAutoRenewal(payload);
      dispatch(showSuccessSnackbar("Auto Renewal added successfully!"));
      unSetDialog("auto_renewal");
    } catch (ex) {
      dispatch(showErrorSnackbar(ex.message));
    }
  };

  return (
    <React.Fragment>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={12} className="row" pt={8}>
            <Grid item md={6}>
              <CustomCheckBox
                label="Enable"
                name="isEnabled"
                type="checkbox"
                my={2}
                fullWidth
                errors={errors}
              />
            </Grid>
          </Grid>
          <DialogActions>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<ReplayIcon />}
              endIcon={isRenewSubmitting ? <CircularProgress size={24} /> : null}
              disabled={false}
            >
              Save
            </Button>

            <Button variant="text" onClick={() => unSetDialog("auto_renewal")} color="primary">
              Close
            </Button>
          </DialogActions>
        </form>
      </FormProvider>
    </React.Fragment>
  );
};
export default AutoRenewal;
